export default "__VITE_ASSET__Cvdk9yPt__"